import { chatbotHttp as api } from "./chatbotApi";

const root = (botId) => `/bots/${encodeURIComponent(botId)}`;
const encode = encodeURIComponent;

const unwrap = (response) => {
  if (response.data?.data == null) throw new Error("The lead service returned an invalid response.");
  return response.data.data;
};

const request = (botId, path, method = "get", data, params) =>
  api.request({ url: `${root(botId)}${path}`, method, data, params }).then(unwrap);

export const listLeads = (botId, params = {}) => request(botId, "/leads", "get", undefined, params);
export const createLead = (botId, data) => request(botId, "/leads", "post", data);
export const getLead = (botId, leadId) => request(botId, `/leads/${encode(leadId)}`);
export const updateLead = (botId, leadId, data) => request(botId, `/leads/${encode(leadId)}`, "patch", data);
export const archiveLead = (botId, leadId) => request(botId, `/leads/${encode(leadId)}`, "delete");
export const addLeadContact = (botId, leadId, data) =>
  request(botId, `/leads/${encode(leadId)}/contacts`, "post", data);
export const listLeadEvents = (botId, leadId, offset = 0) =>
  request(botId, `/leads/${encode(leadId)}/events`, "get", undefined, { offset });
export const addLeadNote = (botId, leadId, data) =>
  request(botId, `/leads/${encode(leadId)}/notes`, "post", data);
const contact = (leadId, contactId) => `/leads/${encode(leadId)}/contacts/${encode(contactId)}`;
export const getLeadPermissions = (botId, leadId, contactId) =>
  request(botId, `${contact(leadId, contactId)}/permissions`);
export const addLeadPermission = (botId, leadId, contactId, data) =>
  request(botId, `${contact(leadId, contactId)}/permissions`, "post", data);
export const listLeadSuppressions = (botId, leadId, contactId) =>
  request(botId, `${contact(leadId, contactId)}/suppressions`);
export const suppressLeadContact = (botId, leadId, contactId, data) =>
  request(botId, `${contact(leadId, contactId)}/suppressions`, "post", data);
export const releaseLeadSuppression = (botId, leadId, contactId, suppressionId, data) =>
  request(botId, `${contact(leadId, contactId)}/suppressions/${encode(suppressionId)}/release`, "post", data);

export const listLeadConnections = (botId) => request(botId, "/lead-discovery/connections");
export const createLeadConnection = (botId, data) => request(botId, "/lead-discovery/connections", "post", data);
export const updateLeadConnection = (botId, connectionId, data) =>
  request(botId, `/lead-discovery/connections/${encode(connectionId)}`, "patch", data);
export const listLeadSearches = (botId) => request(botId, "/lead-discovery/runs");
export const createLeadSearch = (botId, data) => request(botId, "/lead-discovery/runs", "post", data);
export const listLeadSearchResults = (botId, runId, offset = 0) =>
  request(botId, `/lead-discovery/runs/${encode(runId)}/results`, "get", undefined, { offset });
export const cancelLeadSearch = (botId, runId) =>
  request(botId, `/lead-discovery/runs/${encode(runId)}/cancel`, "post");

export const listLeadSequences = (botId) => request(botId, "/lead-outreach/sequences");
export const createLeadSequence = (botId, data) =>
  request(botId, "/lead-outreach/sequences", "post", data);
export const updateLeadSequence = (botId, sequenceId, data) =>
  request(botId, `/lead-outreach/sequences/${encode(sequenceId)}`, "put", data);
export const approveLeadSequence = (botId, sequenceId) =>
  request(botId, `/lead-outreach/sequences/${encode(sequenceId)}/approve`, "post");
export const previewLeadSequence = (botId, leadId, sequenceId) =>
  request(botId, `/leads/${encode(leadId)}/lead-outreach/sequences/${encode(sequenceId)}/preview`, "post");
export const enrollLeadSequence = (botId, leadId, sequenceId, data) =>
  request(botId, `/leads/${encode(leadId)}/lead-outreach/sequences/${encode(sequenceId)}/enroll`, "post", data);
export const listLeadEnrollments = (botId, leadId) =>
  request(botId, `/leads/${encode(leadId)}/lead-outreach/enrollments`);
export const updateLeadEnrollment = (botId, enrollmentId, data) =>
  request(botId, `/lead-outreach/enrollments/${encode(enrollmentId)}/state`, "post", data);

export function leadError(error) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((item) =>
    `${item.loc?.slice(1).join(".")}: ${item.msg}`).join("; ");
  return error?.response?.data?.message || error?.message || "Unable to complete this lead operation.";
}
